import { KHFileInfo } from '../../../../models';

/* istanbul ignore file */
export class ReportSiteData {
    id?: string;
    [key: string]: Date | KHFileInfo[] | ReportSiteData[] | any | number | string;
}

export const REPORT_SITE_DATA_SITE_STATUS = {
    Active: "Active",
    Inactive: "Inactive"
};
